const VALUES = {
  PRICING_TYPE_SUM: 'PRICING_TYPE_SUM',
  PRICING_TYPE_CUSTOM: 'PRICING_TYPE_CUSTOM',
};

export default VALUES;
